export default {
  data() {
    return {
      userHasInteracted: false,
    }
  },
  methods: {
    markUserInteraction() {
      this.userHasInteracted = true
      window.removeEventListener('click', this.markUserInteraction)
      window.removeEventListener('keydown', this.markUserInteraction)
      window.removeEventListener('touchstart', this.markUserInteraction)
    },
  },
  mounted() {
    window.addEventListener('click', this.markUserInteraction)
    window.addEventListener('keydown', this.markUserInteraction)
    window.addEventListener('touchstart', this.markUserInteraction)
  },
  beforeDestroy() {
    window.removeEventListener('click', this.markUserInteraction)
    window.removeEventListener('keydown', this.markUserInteraction)
    window.removeEventListener('touchstart', this.markUserInteraction)
  },
}
